/**
 * Custom AJAX Cart functionality
 * - Handle remove items
 * - Update cart quantities
 * - Maintain consistency with drawer cart
 */

document.addEventListener('DOMContentLoaded', function() {
  // Remove item when clicking "Remove" link
  document.addEventListener('click', function(e) {
    if (e.target.matches('.ajaxcart__remove-item')) {
      e.preventDefault();
      const key = e.target.getAttribute('data-id');
      
      // Show loading state
      const $row = $('.ajaxcart__row[data-line="' + $(e.target).closest('.ajaxcart__row').data('line') + '"]');
      $row.addClass('is-loading');
      $row.parent().addClass('is-removed');
      
      // Remove the item via AJAX
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: key,
          quantity: 0
        },
        dataType: 'json',
        success: function(cart) {
          forceCartRefresh();
        },
        error: function() {
          forceCartRefresh();
        }
      });
    }
  });

  // Update cart when clicking the update button
  document.addEventListener('click', function(e) {
    if (e.target.matches('.ajaxcart__update-button')) {
      e.preventDefault();
      updateCart();
    }
  });

  // Handle Enter key press on quantity inputs
  $(document).on('keydown', '.ajaxcart__qty-num', function(e) {
    if (e.keyCode === 13) { // Enter key
      e.preventDefault();
      
      // Force blur on all inputs to ensure focus is completely removed
      $('input').blur();
      
      // Reset any active element state
      if (document.activeElement && document.activeElement !== document.body) {
        document.activeElement.blur();
      }
      
      // Update cart with forced refresh approach
      handleEnterKeyUpdate();
      
      return false;
    }
  });

  // Special handler for Enter key updates
  function handleEnterKeyUpdate() {
    // Show loading state
    $('body').addClass('drawer--is-loading');
    
    // Get all the quantity inputs and their values
    const updates = {};
    $('.ajaxcart__qty-num').each(function() {
      const id = $(this).attr('data-id');
      const qty = parseInt($(this).val(), 10) || 0;
      updates[id] = qty;
    });
    
    // Update cart with a direct POST request
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { updates: updates },
      dataType: 'json',
      complete: function() {
        // Force a complete refresh of the cart drawer
        forceCartRefresh();
      }
    });
  }

  // Standard cart update function
  function updateCart() {
    // Show loading state on the drawer
    $('body').addClass('drawer--is-loading');
    
    // Get all the quantity inputs and their values
    const updates = {};
    $('.ajaxcart__qty-num').each(function() {
      const id = $(this).attr('data-id');
      const qty = parseInt($(this).val(), 10) || 0;
      updates[id] = qty;
    });
    
    // Use Shopify API to update cart
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { updates: updates },
      dataType: 'json',
      success: function(cart) {
        forceCartRefresh();
      },
      error: function(error) {
        console.error('Error updating cart:', error);
        forceCartRefresh();
      }
    });
  }

  // Force a complete refresh of the cart
  function forceCartRefresh() {
    // Remove loading state immediately
    $('body').removeClass('drawer--is-loading');
    
    // Force close and reopen the cart drawer to guarantee a complete refresh
    if (typeof timber !== 'undefined' && timber.RightDrawer) {
      // Only if the drawer is currently open
      if (timber.RightDrawer.drawerIsOpen) {
        // Close and reopen with a slight delay
        timber.RightDrawer.close();
        
        setTimeout(function() {
          // Reopen the drawer
          timber.RightDrawer.open();
          
          // Refresh the cart contents
          ajaxCart.load();
        }, 300);
      } else {
        // Just refresh the cart content
        ajaxCart.load();
      }
    } else {
      // Fallback to standard refresh
      ShopifyAPI.getCart(function(cart) {
        if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.buildCart === 'function') {
          ajaxCart.buildCart(cart);
        }
      });
    }
  }

  // Auto-update cart when clicking the checkout button if quantities have changed
  document.addEventListener('click', function(e) {
    if (e.target.matches('.cart__checkout')) {
      const hasChanges = $('.ajaxcart__qty-num').toArray().some(function(input) {
        return $(input).data('original-value') !== undefined && 
               $(input).data('original-value') !== $(input).val();
      });
      
      if (hasChanges) {
        e.preventDefault();
        e.stopPropagation();
        updateCart();
      }
    }
  });

  // Prevent form submission when pressing Enter
  $(document).on('submit', '.ajaxcart', function(e) {
    const hasQuantityFocus = $(document.activeElement).hasClass('ajaxcart__qty-num');
    if (hasQuantityFocus) {
      e.preventDefault();
      handleEnterKeyUpdate();
      return false;
    }
  });
  
  // Store original values for quantity inputs when cart loads
  function storeOriginalQuantities() {
    $('.ajaxcart__qty-num').each(function() {
      $(this).data('original-value', $(this).val());
    });
  }
  
  // Run when cart drawer opens
  $(document).on('ajaxCart.afterCartLoad', function() {
    storeOriginalQuantities();
  });
  
  // Call it once on page load in case the cart is already open
  storeOriginalQuantities();
});